import React from 'react';

// GLOBAL DEPENDENCIES
import clsx from 'clsx';

// GLOBAL COMPONENTS
import Form from 'core/form/Form';

// STYLES
import styles from '../PriceAdjustment/styles.module.scss';

const PriceAdjustmentTable = ({ adjustmentHistory }) => {

  // RENDER
  return (
    <>
      <Form.Row className="w-100">
        <Form.Col cols={{ sm: 24, lg: 6 }} className={styles.col}>
          <Form.Label>Price Adjustment History</Form.Label>
        </Form.Col>
        <Form.Col cols={{ sm: 24, lg: 16 }} className={styles.col}>
          <div className={styles.table}>
            <div className={clsx(styles['table--row'], styles['table--row__head'])}>
              <span>Updated On</span>
              <span>Original Price</span>
              <span>Price Adjustment</span>
              <span>Adjustment</span>
            </div>
            {adjustmentHistory.map(({ created_date, original_price, price_after_adjustment, adjustment }, index) => (
              <div key={`${created_date}-${index}`} className={styles['table--row']}>
                <span>{created_date}</span>
                <span>{original_price}</span>
                <span>{price_after_adjustment}</span>
                <span>{adjustment}</span>
              </div>
            ))}
          </div>
        </Form.Col>
      </Form.Row>
    </>
  );
};

// EXPORT
export default PriceAdjustmentTable;
